const $Storage = (_1, _2) => ({tag: "Storage", _1, _2});
const Key = x => x;
const Storage = value0 => value1 => $Storage(value0, value1);
const setJSONItem = dictEncode => v => v._2(dictEncode);
const getJSONItem = dictDecode => v => v._1(dictDecode);
export {$Storage, Key, Storage, getJSONItem, setJSONItem};
